import React from 'react';
import classNames from 'classnames';

import Block from './Block';

export function HBlocks({count, size = 'md', type = null}) {
    return (
        <div className={'loading--blocks loading--blocks__horizontal'}>
            <div
                className={classNames('loading--blocks--items', {
                    [`loading--block__${size}`]: !!size,
                })}
            >
                {Array.from(new Array(count), (u, index) => (
                    <Block
                        key={`block--${String(index).padStart(3, '0')}`}
                        size={null}
                        type={type}
                    />
                ))}
            </div>
        </div>
    );
}

export default HBlocks;
